var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89516 2.63963C4.1289 2.24327 4.55478 2 5.01494 2H14.8648C15.3249 2 15.7508 2.24326 15.9846 2.63963L18.6995 7.24335C18.9792 7.71761 18.9298 8.31662 18.5762 8.73864L10.9363 17.8564C10.4167 18.4765 9.463 18.4765 8.94342 17.8564L1.30357 8.73864C0.949954 8.31662 0.900542 7.71761 1.18023 7.24335L3.89516 2.63963ZM4.72053 4.38981L3.09955 7.13852H5.86602L4.72053 4.38981ZM6.12477 3.6L7.16324 6.09192L8.6047 3.6H6.12477ZM11.2702 3.6L12.7531 6.18206L13.8316 3.6H11.2702ZM15.204 4.46574L14.0875 7.13852H16.7802L15.204 4.46574ZM11.4573 7.13852L9.93727 4.49175L8.40623 7.13852H11.4573ZM8.16438 8.73852H11.7721L9.94821 14.2055L8.16438 8.73852ZM6.48136 8.73852H3.39089L8.45236 14.7791L6.48136 8.73852ZM11.4542 14.747L13.4588 8.73852H16.4888L11.4542 14.747Z",
    fill: "#2B391C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.4893404b476928fca511e4230693d3ef.svg";
export { ForwardRef as ReactComponent };